import { render, staticRenderFns } from "./auto-form.vue?vue&type=template&id=677f2876&scoped=true&"
import script from "./auto-form.vue?vue&type=script&lang=js&"
export * from "./auto-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677f2876",
  null
  
)

export default component.exports